import React, { useEffect, useState } from "react";
import { Table, Button, Form, Modal, Dropdown } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";
import Cookies from "universal-cookie";
import {
  FiEdit,
  FiTrash,
  FiEye,
  FiChevronLeft,
  FiChevronRight,
  FiDownload,
  FiFileText,
  FiFile,
} from "react-icons/fi";
import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

const API_HOST = process.env.REACT_APP_API_URL;
const API = process.env.REACT_APP_API_KEY;
const cookies = new Cookies();

const Empresas = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [errors, setErrors] = useState({});
  const [selectedItem, setSelectedItem] = useState(null);

  const [formData, setFormData] = useState({
    nombreTipoCliente: "",
    descuento: "",
  });

  const [editingId, setEditingId] = useState(null);

  const itemsPerPageOptions = [5, 10, 20, 50];

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    filterData();
  }, [searchTerm, data]);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.nombreTipoCliente.trim()) {
      newErrors.nombreTipoCliente = "El nombre de la empresa es obligatorio";
    }

    if (!formData.descuento) {
      newErrors.descuento = "El porcentaje de descuento es obligatorio";
    } else if (isNaN(formData.descuento)) {
      newErrors.descuento = "Debe ser un número válido";
    } else if (formData.descuento < 0 || formData.descuento > 100) {
      newErrors.descuento = "El descuento debe estar entre 0 y 100";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleView = (item) => {
    setSelectedItem(item);
    setShowViewModal(true);
  };

  const handleCloseViewModal = () => {
    setShowViewModal(false);
  };

  const fetchData = async () => {
    const bearertoken = cookies.get("token");
    try {
      const response = await fetch(`${API_HOST}/tipoclientes`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${bearertoken}`,
          API: API,
        },
      });
      const result = await response.json();
      setData(result);
      setFilteredData(result);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const filterData = () => {
    const filtered = data.filter(
      (item) =>
        item.nombreTipoCliente
          .toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        item.descuento.toString().includes(searchTerm)
    );
    setFilteredData(filtered);
    setCurrentPage(0);
  };

  const handleShowModal = (item = null) => {
    if (item) {
      const { idTipoCliente, ...filteredItem } = item;
      setFormData(filteredItem);
      setEditingId(item.idTipoCliente);
    } else {
      setFormData({
        nombreTipoCliente: "",
        descuento: "",
      });
      setEditingId(null);
    }
    setErrors({});
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (errors[e.target.name]) {
      setErrors({ ...errors, [e.target.name]: null });
    }
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      Swal.fire(
        "Error",
        "Por favor complete todos los campos requeridos",
        "error"
      );
      return;
    }

    const method = editingId ? "PUT" : "POST";
    const url = editingId ? `/tipoclientes/${editingId}` : "/tipoclientes";

    try {
      const bearertoken = cookies.get("token");
      const response = await fetch(`${API_HOST + url}`, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${bearertoken}`,
          API: API,
        },
        body: JSON.stringify(formData),
      });
      if (!response.ok) throw new Error("Error en la solicitud");

      Swal.fire(
        "Éxito",
        editingId ? "Actualizado correctamente" : "Creado correctamente",
        "success"
      );
      fetchData();
      handleCloseModal();
    } catch (error) {
      Swal.fire("Error", "Hubo un problema en la operación", "error");
    }
  };

  const handleDelete = async (id) => {
    const bearertoken = cookies.get("token");
    Swal.fire({
      title: "¿Estás seguro?",
      text: "No podrás revertir esto!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await fetch(`${API_HOST}/tipoclientes/${id}`, {
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${bearertoken}`,
              API: API,
            },
          });
          Swal.fire("Eliminado!", "El registro ha sido eliminado.", "success");
          fetchData();
        } catch (error) {
          Swal.fire("Error", "No se pudo eliminar el registro", "error");
        }
      }
    });
  };

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(0);
  };

  const pageCount = Math.ceil(filteredData.length / itemsPerPage);
  const displayedData = filteredData.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );


  const formatDate = (dateString) => {
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };
    return new Date(dateString).toLocaleDateString("es-ES", options);
  };

  const exportToExcel = () => {

    const excelData = filteredData.map((item) => ({
      ID: item.idTipoCliente,
      Empresa: item.nombreTipoCliente,
      "Descuento (%)": item.descuento,
      "Fecha Creación": new Date(item.createdAt).toLocaleDateString("es-ES"),
      "Última Actualización": new Date(item.updatedAt).toLocaleDateString(
        "es-ES"
      ),
    }));

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(excelData);


    XLSX.utils.book_append_sheet(workbook, worksheet, "Empresas");


    const colWidths = [
      { wch: 5 },
      { wch: 30 },
      { wch: 12 },
      { wch: 15 },
      { wch: 15 },
    ];
    worksheet["!cols"] = colWidths;

    
    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "2c3e50" } }, 
      alignment: { horizontal: "center" },
      border: {
        top: { style: "thin", color: { rgb: "1a1a1a" } },
        bottom: { style: "thin", color: { rgb: "1a1a1a" } },
        left: { style: "thin", color: { rgb: "1a1a1a" } },
        right: { style: "thin", color: { rgb: "1a1a1a" } },
      },
    };

    const range = XLSX.utils.decode_range(worksheet["!ref"]);
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const headerCell = XLSX.utils.encode_cell({ r: range.s.r, c: C });

      if (!worksheet[headerCell].s) worksheet[headerCell].s = {};
      Object.assign(worksheet[headerCell].s, headerStyle);


      for (let R = range.s.r + 1; R <= range.e.r; ++R) {
        const cell = XLSX.utils.encode_cell({ r: R, c: C });
        if (!worksheet[cell]) continue;
        if (!worksheet[cell].s) worksheet[cell].s = {};
        worksheet[cell].s.border = {
          top: { style: "thin", color: { rgb: "e0e0e0" } },
          bottom: { style: "thin", color: { rgb: "e0e0e0" } },
          left: { style: "thin", color: { rgb: "e0e0e0" } },
          right: { style: "thin", color: { rgb: "e0e0e0" } },
        };

  
        if ([0, 2, 3, 4].includes(C)) {
          worksheet[cell].s.alignment = { horizontal: "center" };
        }
      }
    }

    const title = "Listado de Empresas (Tipos de Cliente)";
    const company = "MBOX";
    const date = new Date().toLocaleDateString("es-ES", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });

    const infoSheet = XLSX.utils.aoa_to_sheet([
      [title],
      [""],
      [`Empresa: ${company}`],
      [`Fecha de exportación: ${date}`],
      [`Total registros: ${filteredData.length}`],
      [""],
    ]);

  
    infoSheet["A1"].s = { font: { bold: true, size: 16 } };
    infoSheet["A3"].s = { font: { italic: true } };
    infoSheet["A4"].s = { font: { italic: true } };
    infoSheet["A5"].s = { font: { bold: true } };

    XLSX.utils.book_append_sheet(workbook, infoSheet, "Informe");

    XLSX.writeFile(
      workbook,
      `Empresas_${new Date().toISOString().slice(0, 10)}.xlsx`
    );
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
  
    doc.setFontSize(18);
    doc.text("Listado de Empresas (Tipos de Cliente)", 14, 15);
  
  
    doc.setFontSize(10);
    doc.text(`Exportado: ${new Date().toLocaleString()}`, 14, 22);
  
    
    autoTable(doc, {
      head: [["ID", "Empresa", "Descuento (%)", "Fecha Creación"]],
      body: filteredData.map((item) => [
        item.idTipoCliente,
        item.nombreTipoCliente,
        item.descuento,
        new Date(item.createdAt).toLocaleDateString("es-ES"),
      ]),
      startY: 25,
      styles: {
        fontSize: 8,
        cellPadding: 1,
      },
      headStyles: {
        fillColor: [41, 128, 185],
        textColor: 255,
        fontStyle: "bold",
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245],
      },
      tableWidth: 'auto', 
      margin: { left: 10, right: 10 }, 
    });
  

    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.text(
        `Página ${i} de ${pageCount}`,
        doc.internal.pageSize.width - 25,
        doc.internal.pageSize.height - 5
      );
    }
  
    doc.save("empresas.pdf");
  };
  
  return (
    <div className='container-fluid mt-4'>
      <div className='card border-0 shadow-sm'>
        <div className='card-body'>
          <div className='d-flex justify-content-between mb-4'>
            <h5 className='card-title mb-0'>Gestión de Tipo de Cliente</h5>
            <div>
              <Dropdown className='d-inline me-2'>
                <Dropdown.Toggle variant='outline-primary' size='sm'>
                  <FiDownload className='me-1' /> Exportar
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={exportToExcel}>
                    <FiFileText className='me-2' /> Excel (.xlsx)
                  </Dropdown.Item>
                  <Dropdown.Item onClick={exportToPDF}>
                    <FiFile className='me-2' /> PDF (.pdf)
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <Button
                variant='success'
                onClick={() => handleShowModal()}
                size='sm'
              >
                Agregar Nuevo
              </Button>
            </div>
          </div>
               <div className='d-flex justify-content-between mb-3'>
                      <Form.Control
                        type='text'
                        placeholder='Buscar por moneda o tasa...'
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{ width: "70%" }}
                        className='border'
                      />
                      <div className='d-flex align-items-center'>
                        <span className='me-2 text-muted'>Mostrar:</span>
                        <Form.Select
                          value={itemsPerPage}
                          onChange={handleItemsPerPageChange}
                          style={{ width: "80px" }}
                          className='border'
                          size='sm'
                        >
                          {itemsPerPageOptions.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </Form.Select>
                      </div>
                    </div>

          <div className='table-responsive'>
            <Table hover className='mb-0'>
              <thead>
                <tr>
                  <th className='border-top-0'>ID</th>
                  <th className='border-top-0'>Empresa</th>
                  <th className='border-top-0'>% Descuento</th>
                  <th className='border-top-0 text-end'>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {displayedData.map((item) => (
                  <tr key={item.idTipoCliente}>
                    <td className='text-muted'>{item.idTipoCliente}</td>
                    <td>{item.nombreTipoCliente}</td>
                    <td>{item.descuento}%</td>
                    <td className='text-end'>
                      <Button
                        variant='outline-warning'
                        onClick={() => handleShowModal(item)}
                        className='me-2'
                        title='Editar'
                        size='sm'
                      >
                        <FiEdit />
                      </Button>
                      <Button
                        variant='outline-danger'
                        onClick={() => handleDelete(item.idTipoCliente)}
                        className='me-2 action-btn'
                        title='Eliminar'
                        size='sm'
                      >
                        <FiTrash />
                      </Button>
                      <Button
                        variant='outline-primary'
                        onClick={() => handleView(item)}
                        title='Ver detalles'
                        size='sm'
                      >
                        <FiEye />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

          <div className='d-flex justify-content-between align-items-center mt-3'>
            <div className='text-muted small'>
              Mostrando {displayedData.length} de {filteredData.length}{" "}
              registros
            </div>
            <ReactPaginate
              previousLabel={<FiChevronLeft size={14} />}
              nextLabel={<FiChevronRight size={14} />}
              pageCount={pageCount}
              onPageChange={handlePageClick}
              containerClassName={"pagination mb-0"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              activeClassName={"active"}
              breakLabel='...'
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
            />
          </div>
        </div>
      </div>

      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton className='border-bottom'>
          <Modal.Title>{editingId ? "Editar" : "Agregar"} Empresa</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className='mb-3'>
              <Form.Label>
                <span className='text-danger'>*</span> Nombre de Empresa
              </Form.Label>
              <Form.Control
                type='text'
                name='nombreTipoCliente'
                value={formData.nombreTipoCliente}
                onChange={handleChange}
                isInvalid={!!errors.nombreTipoCliente}
                className='border'
              />
              <Form.Control.Feedback type='invalid'>
                {errors.nombreTipoCliente}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className='mb-3'>
              <Form.Label>
                <span className='text-danger'>*</span> Porcentaje de Descuento
              </Form.Label>
              <Form.Control
                type='number'
                name='descuento'
                value={formData.descuento}
                onChange={handleChange}
                isInvalid={!!errors.descuento}
                min='0'
                max='100'
                className='border'
              />
              <Form.Control.Feedback type='invalid'>
                {errors.descuento}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className='border-top'>
          <Button variant='outline-secondary' onClick={handleCloseModal}>
            Cancelar
          </Button>
          <Button variant='primary' onClick={handleSubmit}>
            {editingId ? "Actualizar" : "Guardar"}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showViewModal} onHide={handleCloseViewModal} centered>
        <Modal.Header closeButton className='border-bottom'>
          <Modal.Title>
            <FiEye className='me-2 text-primary' />
            Detalles de Empresa
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedItem && (
            <div>
              <div className='mb-3'>
                <h6 className='text-muted mb-2'>Información Básica</h6>
                <div className='ps-3'>
                  <p className='mb-2'>
                    <span className='fw-medium'>ID:</span>{" "}
                    {selectedItem.idTipoCliente}
                  </p>
                  <p className='mb-2'>
                    <span className='fw-medium'>Nombre:</span>{" "}
                    {selectedItem.nombreTipoCliente}
                  </p>
                  <p className='mb-0'>
                    <span className='fw-medium'>Descuento:</span>{" "}
                    {selectedItem.descuento}%
                  </p>
                </div>
              </div>

              <div className='mb-3'>
                <h6 className='text-muted mb-2'>Registro</h6>
                <div className='ps-3'>
                  <p className='mb-2'>
                    <span className='fw-medium'>Creado:</span>{" "}
                    {formatDate(selectedItem.createdAt)}
                  </p>
                  <p className='mb-0'>
                    <span className='fw-medium'>Actualizado:</span>{" "}
                    {formatDate(selectedItem.updatedAt)}
                  </p>
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className='border-top'>
          <Button variant='outline-secondary' onClick={handleCloseViewModal}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Empresas;
